module.exports = __webpack_public_path__ + "img/doc-flow-logo-alt.822ab94c.svg";